const uri = process.env.REACT_APP_BACKEND_URI;
export { uri }